import React, { FC } from 'react';
import StudentTasksSideBarContent from './StudentTasksSideBarContent';
import CurriculumGoalsSidebarContent from './CurriculumGoalsSidebarContent';
import { useTranslation } from 'react-i18next';
import { TabbedContent } from '../../../../shared/components';

type StudentSidebarContentProps = {
  showTabs: boolean;
};

export const StudentSidebarContent: FC<StudentSidebarContentProps> = ({ showTabs }) => {
  const { t } = useTranslation();

  return (
    <TabbedContent
      ariaPrefix="trajectory-sidebar"
      hideTabs={!showTabs}
      content={[
        {
          title: t('trajectory.sidebar.assignments.title'),
          data: <StudentTasksSideBarContent />,
        },
        {
          title: t('trajectory.sidebar.curriculumGoals.title'),
          data: <CurriculumGoalsSidebarContent />,
        },
      ]}
    />
  );
};
